import { useEffect, useRef } from 'react';
export function useOnChange(value, callback) {
    var previousValueRef = useRef();
    useEffect(function () {
        previousValueRef.current = value;
    });
    var previousValue = previousValueRef.current;
    useEffect(function () {
        if (JSON.stringify(value) === JSON.stringify(previousValue))
            return;
        return callback();
    }, [value, previousValue, callback]);
}
export default useOnChange;
